import styled from "styled-components";

import { device } from "@/style/constants";
import { pxToRem } from "@/style/utils";
import {
  PrimaryMobileModalButtonColorsWithStates,
  PrimaryModalButtonColorsWithStates,
  SecondaryMobileModalButtonColorsWithStates,
  SecondaryModalButtonColorsWithStates,
} from "@/style/common";

export const MessageWrapper = styled.div`
  margin: 10vh ${pxToRem(32)};
  h1 {
    font-weight: 500;
    font-size: ${pxToRem(25)};
    line-height: ${pxToRem(61)};
    color: ${({ theme }) => theme.color_modal_mobile_h1_text};
    letter-spacing: -0.02em;
  }
  p {
    font-weight: 500;
    font-size: ${pxToRem(16)};
    line-height: ${pxToRem(26)};
    color: ${({ theme }) => theme.color_modal_mobile_p_text};
    letter-spacing: ${pxToRem(0.25)};
    margin-top: ${pxToRem(12)};
  }

  @media ${device.tablet} {
    margin: 72px ${pxToRem(94)} 48px;
  }

  @media ${device.laptop} {
    margin: ${pxToRem(64)} ${pxToRem(48)} 0px;
    height: calc(100% - ${pxToRem(64)} - ${pxToRem(96)});
    h1 {
      color: ${({ theme }) => theme.color_modal_h1_text};
    }
    p {
      color: ${({ theme }) => theme.color_modal_p_text};
    }
  }
`;

export const ButtonWrapper = styled.div`
  position: absolute;
  left: 0;
  padding: ${pxToRem(24)} ${pxToRem(48)};
  bottom: 0px;
  width: 100%;
  text-align: center;
  background: ${({ theme }) => theme.color_modal_mobile_btn_container_background};
  .modal-btn {
    font-weight: 700;
    cursor: pointer;
    display: inline-block;
    width: 100%;
    height: ${pxToRem(64)};
    line-height: ${pxToRem(64)};
    font-size: ${pxToRem(16)};
    border-radius: ${pxToRem(9.6)};
    ${PrimaryMobileModalButtonColorsWithStates}
  }
  .modal-btn-secondary {
    font-weight: 700;
    cursor: pointer;
    display: inline-block;
    width: 100%;
    height: ${pxToRem(64)};
    line-height: ${pxToRem(64)};
    font-size: ${pxToRem(16)};
    border-radius: ${pxToRem(9.6)};
    margin-bottom: ${pxToRem(15)};
    ${SecondaryMobileModalButtonColorsWithStates}
  }

  @media ${device.laptop} {
    display: flex;
    justify-content: center;
    background: ${({ theme }) => theme.color_modal_btn_container_background};
    border-radius: 0px 0px ${pxToRem(8)} ${pxToRem(8)};
    .modal-btn {
      width: ${pxToRem(198)};
      height: ${pxToRem(48)};
      line-height: ${pxToRem(48)};
      margin: 0rem ${pxToRem(5)};
      ${PrimaryModalButtonColorsWithStates}
    }
    .modal-btn-secondary {
      width: ${pxToRem(198)};
      height: ${pxToRem(48)};
      line-height: ${pxToRem(48)};
      margin: 0rem ${pxToRem(5)};
      ${SecondaryModalButtonColorsWithStates}
    }
  }
`;
